<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-[200] flex items-start justify-center px-4 py-4 sm:py-8 overflow-y-auto bg-black/50 backdrop-blur-sm"
    @click.self="closeModal"
  >
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-3xl my-2 sm:my-4 max-h-[calc(100dvh-2rem)] flex flex-col overflow-hidden transform transition-all animate-in fade-in zoom-in duration-300 text-left relative">
      <div class="px-4 sm:px-6 py-4 bg-[#0d4169] text-white flex items-center justify-between rounded-t-xl shrink-0">
        <h2 class="text-lg font-bold m-0">{{ editShift ? 'Edit Working Shift' : 'Add Working Shift' }}</h2>
        <button type="button" class="p-1 hover:bg-white/10 rounded-full transition-colors text-white" @click="closeModal">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
        </button>
      </div>

      <form class="flex flex-col flex-1 min-h-0 overflow-hidden" @submit.prevent="handleSubmit">
        <div class="p-4 sm:p-8 overflow-y-auto flex-1">
          <div class="grid grid-cols-1 md:grid-cols-12 gap-x-6 gap-y-4">
            <div class="md:col-span-8 flex flex-col gap-1.5">
              <label class="text-[0.85rem] font-semibold text-[#1e293b]">Shift Name</label>
              <input
                v-model.trim="form.shiftName"
                type="text"
                placeholder="Enter shift name"
                class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
                required
              >
            </div>

            <div class="md:col-span-4 flex flex-col gap-1.5">
              <label class="text-[0.85rem] font-semibold text-[#1e293b]">It's Office Hour</label>
              <select
                v-model="form.officeHour"
                class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm bg-white cursor-pointer"
                required
              >
                <option value="" disabled>Select Here</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
          </div>

        
        

          <div class="mt-5 mb-2">
            <span class="inline-block text-[0.75rem] font-bold text-slate-500 bg-slate-100 px-2.5 py-1 rounded">
              Timetable
            </span>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-4">
            <div class="flex flex-col gap-1.5">
              <label class="text-[0.85rem] font-semibold text-[#1e293b]">Timetable Name</label>
              <input
                v-model.trim="form.timeName"
                type="text"
                placeholder="Timetable name"
                class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
                required
              >
            </div>
            <div class="flex flex-col gap-1.5">
              <label class="text-[0.85rem] font-semibold text-[#1e293b]">On Duty Time</label>
              <input
                v-model="form.onDutyTime"
                type="time"
                class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
                required
              >
            </div>
            <div class="flex flex-col gap-1.5">
              <label class="text-[0.85rem] font-semibold text-[#1e293b]">Off Duty Time</label>
              <input
                v-model="form.offDutyTime"
                type="time"
                class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
                required
              >
            </div>
          </div>

          <div class="mt-5 mb-2">
            <span class="inline-block text-[0.75rem] font-bold text-slate-500 bg-slate-100 px-2.5 py-1 rounded">
              Working Days
            </span>
          </div>
          <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-x-4 gap-y-2">
            <label class="flex items-center gap-2 text-sm text-[#1e293b] cursor-pointer">
              <input
                v-model="allDaysChecked"
                type="checkbox"
                class="w-3.5 h-3.5 rounded border-slate-300 text-[#0d4169] focus:ring-[#0d4169] cursor-pointer"
              >
              <span class="font-semibold text-[0.8rem]">All Days</span>
            </label>
            <label
              v-for="day in weekDays"
              :key="'d1-' + day.key"
              class="flex items-center gap-2 text-sm text-[#1e293b] cursor-pointer"
            >
              <input
                v-model="form.workingDays"
                type="checkbox"
                :value="day.value"
                class="w-3.5 h-3.5 rounded border-slate-300 text-[#0d4169] focus:ring-[#0d4169] cursor-pointer"
              >
              <span class="font-semibold text-[0.8rem]">{{ day.label }}</span>
            </label>
          </div>

          <div v-if="form.officeHour === 'Yes'" class="mt-6 pt-4 border-t border-slate-100">
            <div class="mb-2">
              <span class="inline-block text-[0.75rem] font-bold text-slate-500 bg-slate-100 px-2.5 py-1 rounded">
                Timetable 2
              </span>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-4">
              <div class="flex flex-col gap-1.5">
                <label class="text-[0.85rem] font-semibold text-[#1e293b]">Timetable Name</label>
                <input
                  v-model.trim="form.timeName2"
                  type="text"
                  placeholder="Timetable name"
                  class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
                  required
                >
              </div>
              <div class="flex flex-col gap-1.5">
                <label class="text-[0.85rem] font-semibold text-[#1e293b]">On Duty Time</label>
                <input
                  v-model="form.onDutyTime2"
                  type="time"
                  class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
                  required
                >
              </div>
              <div class="flex flex-col gap-1.5">
                <label class="text-[0.85rem] font-semibold text-[#1e293b]">Off Duty Time</label>
                <input
                  v-model="form.offDutyTime2"
                  type="time"
                  class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
                  required
                >
              </div>
            </div>

            <div class="mt-5 mb-2">
              <span class="inline-block text-[0.75rem] font-bold text-slate-500 bg-slate-100 px-2.5 py-1 rounded">
                Working Days
              </span>
            </div>
            <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-x-4 gap-y-2">
              <label class="flex items-center gap-2 text-sm text-[#1e293b] cursor-pointer">
                <input
                  v-model="allDaysChecked2"
                  type="checkbox"
                  class="w-3.5 h-3.5 rounded border-slate-300 text-[#0d4169] focus:ring-[#0d4169] cursor-pointer"
                >
                <span class="font-semibold text-[0.8rem]">All Days</span>
              </label>
              <label
                v-for="day in weekDays"
                :key="'d2-' + day.key"
                class="flex items-center gap-2 text-sm text-[#1e293b] cursor-pointer"
              >
                <input
                  v-model="form.workingDays2"
                  type="checkbox"
                  :value="day.value"
                  class="w-3.5 h-3.5 rounded border-slate-300 text-[#0d4169] focus:ring-[#0d4169] cursor-pointer"
                >
                <span class="font-semibold text-[0.8rem]">{{ day.label }}</span>
              </label>
            </div>

          
          </div>
          <div class="mt-5 mb-2">
            <span class="inline-block text-[0.75rem] font-bold text-slate-500 bg-slate-100 px-2.5 py-1 rounded">
              Daily Early &amp; Late Tolerance (Min)
            </span>
          </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-4">
            <div class="flex flex-col gap-1.5">
              <label class="text-[0.85rem] font-semibold text-[#1e293b]">Early Check In</label>
              <input
                v-model.number="form.earlyCheckIn"
                type="number"
                placeholder=""
                class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
                required
              >
            </div>
            <div class="flex flex-col gap-1.5">
              <label class="text-[0.85rem] font-semibold text-[#1e293b]">Late Check In</label>
              <input
                v-model.number="form.lateCheckIn"
                type="number"
             
                placeholder=""
                class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
                required
              >
            </div>
            <div class="flex flex-col gap-1.5">
              <label class="text-[0.85rem] font-semibold text-[#1e293b]">Early Check Out</label>
              <input
                v-model.number="form.earlyCheckOut"
                type="number"
             
                placeholder=""
                class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
                required
              >
            </div>
         
            <div class="flex flex-col gap-1.5">
              <label class="text-[0.85rem] font-semibold text-[#1e293b]">Late Check Out</label>
              <input
                v-model.number="form.lateCheckOut"
                type="number"
              
                placeholder=""
                class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
                required
              >
            </div>
          </div>

          <p v-if="errorMessage" class="mt-4 text-sm text-red-600">{{ errorMessage }}</p>
        </div>

        <div class="px-4 sm:px-8 pb-4 sm:pb-8 pt-4 sm:pt-6 border-t border-slate-100 flex items-center gap-2 sm:gap-0 shrink-0">
          <div class="hidden sm:block flex-1"></div>
          <div class="flex-1 sm:flex-initial flex justify-center min-w-0">
            <button
              type="submit"
              :disabled="saving"
              class="whitespace-nowrap px-5 sm:px-10 py-2.5 bg-[#0d4169] text-white text-sm font-bold rounded-md shadow-md hover:bg-[#0a3354] transition-all active:transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center gap-2 shrink-0"
            >
              <div
                v-if="saving"
                class="h-5 w-5 border-2 border-white/30 border-t-transparent rounded-full animate-spin shrink-0"
              ></div>
              <span v-if="!saving" class="whitespace-nowrap">{{ editShift ? 'Update' : 'Save' }}</span>
            </button>
          </div>
          <div class="shrink-0 sm:flex-1 flex justify-end">
            <button
              type="button"
              class="px-4 sm:px-6 py-2.5 text-sm font-semibold text-slate-500 hover:text-slate-800 transition-colors whitespace-nowrap"
              @click="closeModal"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { computed, reactive, ref, watch, defineProps, defineEmits } from 'vue'

const props = defineProps({
  isOpen: { type: Boolean, default: false },
  editShift: { type: Object, default: null }
})

const emit = defineEmits(['close', 'save'])

const weekDays = [
  { key: 'mon', label: 'Monday', value: '1' },
  { key: 'tue', label: 'Tuesday', value: '2' },
  { key: 'wed', label: 'Wednesday', value: '3' },
  { key: 'thu', label: 'Thursday', value: '4' },
  { key: 'fri', label: 'Friday', value: '5' },
  { key: 'sat', label: 'Saturday', value: '6' },
  { key: 'sun', label: 'Sunday', value: '0' }
]

const allDayValues = weekDays.map((d) => d.value)

const form = reactive(createEmptyForm())
const errorMessage = ref('')
const saving = ref(false)

const allDaysChecked = computed({
  get() {
    return allDayValues.every((v) => form.workingDays.includes(v))
  },
  set(val) {
    form.workingDays = val ? [...allDayValues] : []
  }
})

const allDaysChecked2 = computed({
  get() {
    return allDayValues.every((v) => form.workingDays2.includes(v))
  },
  set(val) {
    form.workingDays2 = val ? [...allDayValues] : []
  }
})

function createEmptyForm() {
  return {
    shiftName: '',
    officeHour: '',
    earlyCheckIn: null,
    earlyCheckOut: null,
    lateCheckIn: null,
    lateCheckOut: null,
    timeName: '',
    onDutyTime: '',
    offDutyTime: '',
    workingDays: [],
    timeName2: '',
    onDutyTime2: '',
    offDutyTime2: '',
    workingDays2: []
  }
}

function resetForm() {
  Object.assign(form, createEmptyForm())
  errorMessage.value = ''
  saving.value = false
}

function toTimeInputValue(value) {
  if (!value) return ''
  const s = String(value).trim()
  const m = /^(\d{1,2}):(\d{2})(?::\d{2})?$/.exec(s)
  if (!m) return s
  return `${String(m[1]).padStart(2, '0')}:${m[2]}`
}

function loadForm(shift) {
  resetForm()
  if (!shift) return

  form.shiftName = shift.shiftName || ''
  form.officeHour = shift.officeHour || ''
  form.earlyCheckIn = shift.earlyCheckIn
  form.earlyCheckOut = shift.earlyCheckOut
  form.lateCheckIn = shift.lateCheckIn
  form.lateCheckOut = shift.lateCheckOut
  form.timeName = shift.timeName || ''
  form.onDutyTime = toTimeInputValue(shift.onDutyTime)
  form.offDutyTime = toTimeInputValue(shift.offDutyTime)
  form.workingDays = [...(shift.workingDays || [])]
  form.timeName2 = shift.timeName2 || ''
  form.onDutyTime2 = toTimeInputValue(shift.onDutyTime2)
  form.offDutyTime2 = toTimeInputValue(shift.offDutyTime2)
  form.workingDays2 = [...(shift.workingDays2 || [])]
}

function closeModal() {
  if (saving.value) return
  emit('close')
}

async function handleSubmit() {
  if (saving.value) return
  errorMessage.value = ''

  if (!form.shiftName || !form.officeHour) {
    errorMessage.value = 'Please fill in all required fields.'
    return
  }

  if (form.workingDays.length < 1) {
    errorMessage.value = 'Please select at least one Working Day.'
    return
  }

  if (form.officeHour === 'Yes') {
    if (!form.timeName2 || !form.onDutyTime2 || !form.offDutyTime2) {
      errorMessage.value = 'Please complete the second timetable fields.'
      return
    }
    if (form.workingDays2.length < 1) {
      errorMessage.value = 'Please select at least one Working Day for the second timetable.'
      return
    }
  }

  const payload = {
    shiftName: form.shiftName,
    officeHour: form.officeHour,
    earlyCheckIn: form.earlyCheckIn,
    earlyCheckOut: form.earlyCheckOut,
    lateCheckIn: form.lateCheckIn,
    lateCheckOut: form.lateCheckOut,
    timeName: form.timeName,
    onDutyTime: form.onDutyTime,
    offDutyTime: form.offDutyTime,
    workingDays: [...form.workingDays],
    timeName2: form.officeHour === 'Yes' ? form.timeName2 : '',
    onDutyTime2: form.officeHour === 'Yes' ? form.onDutyTime2 : '',
    offDutyTime2: form.officeHour === 'Yes' ? form.offDutyTime2 : '',
    workingDays2: form.officeHour === 'Yes' ? [...form.workingDays2] : []
  }

  saving.value = true
  errorMessage.value = ''
  try {
    await new Promise((resolve, reject) => {
      emit('save', payload, { resolve, reject })
    })
  } catch (err) {
    errorMessage.value = err?.message || 'Failed to save shift'
  } finally {
    saving.value = false
  }
}

watch(
  () => props.isOpen,
  (open) => {
    if (open) loadForm(props.editShift)
    else resetForm()
  }
)

watch(
  () => form.officeHour,
  (val) => {
    if (val !== 'Yes') {
      form.timeName2 = ''
      form.onDutyTime2 = ''
      form.offDutyTime2 = ''
      form.workingDays2 = []
    }
  }
)
</script>

<style scoped>
.animate-in {
  animation: 0.2s ease-out forwards;
}
.fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}
.zoom-in {
  from { transform: scale(0.95); }
  to { transform: scale(1); }
}
</style>
